export var DixaMessengerCSAT;
(function (DixaMessengerCSAT) {
    DixaMessengerCSAT.defaultLanguage = 'en';
})(DixaMessengerCSAT || (DixaMessengerCSAT = {}));
